import React, { useEffect, useState } from "react";
import "../../assets/styles/Search.css";
import Swal from "sweetalert2";
import iconSearch from "../../icons/icon-search.png";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { config } from "../../config.js";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";
function SearchUser() {
  const [userName, setUserName] = useState("");
  const [domains, setDomains] = useState("");
  const [webSetting, setWebSetting] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiGetSetting();
        if (result && result.status_code === 200) {
          setWebSetting(result.data);
        }
      } catch (error) {
        return Swal.fire({
          icon: "error",
          text: "Lỗi kết nối, vui lòng liên hệ CSKH để được hỗ trợ.",
        });
      }
    };
    fetchData();
  }, []);

  const checkUser = async () => {
    if (!userName) {
      return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
    } else {
      let result = await apiCheckAccount(userName);
      if (result && result?.code === 200) {
        let data = result.data;
        navigate("/profile", { state: { userName, data, webSetting } });
      }
    }
  };

  return (
    <div className="container">
      <div className="app">
        <Header isPageSearch={true} />
        <div className="content">
          <div className="search-user">
            <div style={{ textAlign: "center" }}>
              <span>VUI LÒNG XÁC NHẬN TÀI KHOẢN CỦA BẠN</span>
            </div>
            <div className="input-search">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-search-icon lucide-search"
              >
                <path d="m21 21-4.34-4.34" />
                <circle cx="11" cy="11" r="8" />
              </svg>
              <input
                className="input-account"
                onChange={(e) =>
                  setUserName(e.target.value.toLowerCase().trim())
                }
                type="text"
                placeholder="Nhập tên tài khoản"
              />
              <button className="btn-search-account" onClick={checkUser}>
                KIỂM TRA
              </button>
            </div>
            <div>
              <p className="link-home">
                Link chính thức {webSetting.link_home}
              </p>
            </div>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: webSetting.login_info_notice }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchUser;
